var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13.7,30.4c1,0.7,2.2,0.9,3.3,0.5c1-0.2,1.7,0.3,2.6,0.9c0.8,0.7,1.8,1.1,2.9,1.2c1-0.1,2-0.5,2.8-1.2 c0.7-0.7,1.7-1,2.7-0.9c1.1,0.4,2.3,0.2,3.3-0.5c0.9-0.8,1.3-2,1.2-3.2c0-2.1-1.2-4-3.1-4.9c-0.3-1.4-1.1-6.1-1.9-9.4 c-0.8-3.3-2.5-5.2-5-5.2s-4.2,1.7-5,5.2c-0.8,3.5-1.7,8-1.9,9.4c-1.9,0.9-3.2,2.8-3.2,4.9C12.3,28.4,12.8,29.6,13.7,30.4z  M16.5,23.5c0.2-0.1,0.4-0.3,0.4-0.5c0-0.1,1-5.9,2-9.7s2.5-4.2,3.6-4.2c1.1,0,2.6,0.5,3.6,4.2S28,22.9,28,23 c0,0.1,0.2,0.4,0.5,0.5c1.5,0.6,2.5,2.1,2.6,3.7c0.1,0.8-0.2,1.5-0.7,2.1l-0.7,0.3c-0.5-0.7-1.3-1-2.2-1c-1.5,0-2.3,2.6-5,2.6 c-2.7,0-3.5-2.6-5.1-2.6c-0.8,0-1.7,0.3-2.2,1l-0.7-0.3c-0.5-0.6-0.8-1.3-0.7-2.1C13.9,24.5,16.5,23.6,16.5,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECD5D5",
    d: "M14.5,29.3l0.7,0.3c0.5-0.7,1.4-1,2.2-1c1.6,0,2.4,2.6,5.1,2.6c2.7,0,3.5-2.6,5-2.6c0.9,0,1.7,0.3,2.2,1 l0.7-0.3c0.5-0.6,0.8-1.3,0.7-2.1c-0.1-1.6-1.1-3.1-2.6-3.7C28.2,23.4,28,23.1,28,23c0-0.1-0.9-6-1.9-9.7s-2.5-4.2-3.6-4.2 c-1.1,0-2.6,0.4-3.6,4.2s-2,9.6-2,9.7c0,0.2-0.2,0.4-0.4,0.5c-0.1,0.1-2.7,1-2.7,3.7C13.8,28,14,28.7,14.5,29.3z M18.2,25.1 c0.5-2,0.9-4,1.1-6c0.1-0.4,0.5-0.7,0.9-0.6c0.3,0.1,0.6,0.4,0.5,0.8c-0.2,2.1-0.6,4.2-1.1,6.2c-0.1,0.3-0.4,0.5-0.7,0.5h-0.2 c0,0,0,0-0.1,0C18.2,25.9,18,25.5,18.2,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.6,26C18.6,26,18.6,26,18.6,26l0.3,0c0.3,0,0.6-0.2,0.7-0.5c0.5-2,0.9-4.1,1.1-6.2 c0.1-0.4-0.2-0.7-0.5-0.8c-0.4-0.1-0.8,0.2-0.9,0.6c-0.2,2-0.6,4-1.1,6C18,25.5,18.2,25.9,18.6,26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M18.2,37.3c0.3,0.1,0.6-0.1,0.7-0.5l0.7-2.3c0.1-0.3-0.1-0.7-0.4-0.8h-0.1c-0.3-0.1-0.6,0.1-0.7,0.5 l-0.7,2.3c0,0,0,0.1,0,0.1C17.7,37,17.9,37.3,18.2,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M15.2,36.5c0.8-0.8,1.4-1.7,1.9-2.7c0-0.1,0.1-0.1,0.1-0.2c0.1-0.3-0.1-0.5-0.4-0.6h-0.2 c-0.2-0.1-0.5,0.1-0.6,0.3c-0.4,0.8-0.9,1.5-1.5,2.2c-0.3,0.2-0.4,0.5-0.2,0.8C14.7,36.6,14.9,36.7,15.2,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M26.5,33.7L26.5,33.7c-0.4,0.1-0.6,0.5-0.5,0.8l0.6,2.3c0.1,0.3,0.4,0.6,0.8,0.5c0.3-0.1,0.5-0.4,0.4-0.7 c0,0,0,0,0-0.1l-0.6-2.3C27,33.8,26.7,33.6,26.5,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M31.2,36.3c0.2-0.2,0.2-0.5,0-0.7c0,0-0.1-0.1-0.1-0.1c-0.6-0.7-1.1-1.4-1.5-2.2C29.4,33.1,29.2,33,29,33 h-0.3c-0.3,0.1-0.4,0.5-0.3,0.8c0,0,0,0,0,0c0.5,1,1.2,1.9,2,2.7C30.6,36.7,31,36.6,31.2,36.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose);
export default __webpack_public_path__ + "static/media/nose.03669f097638f9c15d79570003284349.svg";
export { ForwardRef as ReactComponent };